// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import CheckboxFilterControlled from '../../../shared/components/facets/checkbox-filter/controlled';
import CheckboxWithSearchFilterControlled from '../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../shared/components/facets/facet-footer';
import FacetsDateRangePickerControlled from '../../../shared/components/facets/date-range-picker/controlled';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../shared/services/facets';

class ProductSearchFacets extends Component {

    state = {
        dealerLocationExpanded: false,
        registeredDateExpanded: false,
        statusExpanded: false
    };

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.registeredDateExpanded || this.state.dealerLocationExpanded || this.state.statusExpanded;

    render() {

        return (

            <div className='product-search-facets'>
                <CheckboxWithSearchFilterControlled
                    initialState={createHashMap(this.props.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this.props.onDealerItemChange}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this.props.onDealerInputChange}
                    onToggleAll={this.props.onDealerItemsChange}
                    searchInput={this.props.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey='account'
                />
                <CheckboxFilterControlled
                    displayKey='value'
                    initialState={createHashMap(this.props.statusFacet.selectedStatuses, 'key')}
                    isExpanded={this.state.statusExpanded}
                    list={addCollectionLabels(this.props.statusFacet.allowedStatuses, 'value')}
                    minNumberOfItems={4}
                    onChange={this.props.onStatusItemChange}
                    onClick={this.onAccordionToggle.bind(this, 'statusExpanded')}
                    onToggleAll={this.props.onStatusItemsChange}
                    title='STATUS'
                    valueKey='key'
                />
                <FacetsDateRangePickerControlled
                    dateFormat={this.props.dateFormat}
                    dateRange={this.props.registeredDateRange.dateRange}
                    isExpanded={this.state.registeredDateExpanded}
                    maxDate={this.props.registeredDateRange.maxDate}
                    minDate={this.props.registeredDateRange.minDate}
                    onChange={this.props.onDatePickerChange}
                    onClick={this.onAccordionToggle.bind(this, 'registeredDateExpanded')}
                    title='REGISTERED'
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.dealerAccountsFacet)}
                        onApply={this.props.onApply}
                        onReset={this.props.onReset}
                    /> : null}

            </div>
        );

    }

}

ProductSearchFacets.displayName = 'ProductSearchFacets';
ProductSearchFacets.propTypes = {
    dateFormat: PropTypes.string.isRequired,
    dealerAccountsFacet: PropTypes.object.isRequired,
    onApply: PropTypes.func.isRequired,
    onDatePickerChange: PropTypes.func.isRequired,
    onDealerInputChange: PropTypes.func.isRequired,
    onDealerItemChange: PropTypes.func.isRequired,
    onDealerItemsChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onStatusItemChange: PropTypes.func.isRequired,
    onStatusItemsChange: PropTypes.func.isRequired,
    registeredDateRange: PropTypes.object.isRequired,
    statusFacet: PropTypes.object.isRequired
};

export default ProductSearchFacets;



// WEBPACK FOOTER //
// ./src/product/search/components/search-facets.js